import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiHelper } from '@helpers/ui.helper';
import { Router } from '@angular/router';

export interface DialogData {
  barcode: string;
  type: string;
}

@Component({
  selector: 'verification-dialog',
  templateUrl: '../sharedTemplates/verification.dialog.component.html',
})
export class VerificationDialog {
  // elementType = 'svg';
  // format = 'CODE128';
  // lineColor = '#000000';
  // width = 4;
  // height = 150;
  // displayValue = true;
  // fontOptions = '';
  // font = 'monospace';
  // textAlign = 'center';
  // textPosition = 'bottom';
  // textMargin = 10;
  // fontSize = 22;
  // background = '#ffffff';
  // margin = 5;
  // marginTop = 5;
  // marginBottom = 5;
  // marginLeft = 5;
  // marginRight = 5;

  constructor(
    public dialogRef: MatDialogRef<VerificationDialog>,
    private _router: Router,

    private _UiHelper: UiHelper
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
